import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconDownloadOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m12.75 16.19 3.923-3.923a.749.749 0 1 1 1.06 1.06L12 19.062l-5.733-5.733a.75.75 0 1 1 1.06-1.061l3.923 3.922V7.5H1.5v15h21v-15h-9.75zM11.25 6V0h1.5v6H24v16.5a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 22.5V6z" /></svg>
);
